import React, { useContext, useEffect, useRef, useState } from 'react';
import classNames from 'classnames/bind';
import styles from './SocialProfile.module.scss';
import background from '~/assets/background.png';
import { FaFacebook, FaGithub, FaLinkedin, FaEnvelope, FaPhone, FaDownload } from 'react-icons/fa';
import { downloadFile, getData } from '~/helper/apiService';
import images from '~/assets';
import Img from '../Img';
import { ThemeModeContext } from '../Context/ThemeModeProvider';
import { useDarkMode } from '~/hooks/useDarkMode';
import GifViewer from '../GifViewer';

const cx = classNames.bind(styles);

function SocialProfile() {
  const educationRef = useRef();
  const contactRef = useRef();
  const email = 'ngogiaquyendhtn223@gmail.com';
  const phone = '0356197132';
  const { theme } = useContext(ThemeModeContext);
  const [isDarkMode, setIsDarkMode] = useState(useDarkMode());
  const [currentBgrIndex, setCurrentBgrIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);

  const imgBgrList = [
    images.bgr24,
    images.bgr21,
    images.bgr22,
    background,
    images.bgr23,
  ]

  const handleDownloadCv = () => {
    downloadFile('/cv/download', 'software_ngogiaquyen.pdf');
  };

  useEffect(() => {
    setIsDarkMode(theme === 'dark' ? true : false);
  }, [theme]);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (educationRef.current) {
        educationRef.current.classList.add(styles.show);
      }
      if (contactRef.current) {
        contactRef.current.classList.add(styles.show);
      }
    },100);

    return () => clearTimeout(timer); // cleanup
  }, []);

  // Effect to change background image every 10 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setIsTransitioning(true);
      
      // After a short delay, change the image
      setTimeout(() => {
        setCurrentBgrIndex((prevIndex) => (prevIndex + 1) % imgBgrList.length);
        setIsTransitioning(false);
      }, 300);
    }, 8000);

    return () => clearInterval(interval); // cleanup
  }, [imgBgrList.length]);

  return (
    <div className={cx('container')}>
      <div className={cx('bgr')}>
        <Img src={isDarkMode ? images.bgrSocialDark : images.bgrSocialLight} />
      </div>
      
      <div className={cx('profile-header')}>
        <div className={cx('profile-intro')}>
          <div className={cx('left-section')}>
            <div className={cx('avatar-wrap')}>
              <img src={images.avatar2} alt="Avatar" className={cx('avatar')} />
            </div>
            <div className={cx('social-links')}>
              <a href="https://github.com/ngogiaquyen" target="_blank" rel="noopener noreferrer">
                <FaGithub />
              </a>
              <a href="https://www.linkedin.com/in/quyen-ngo-gia" target="_blank" rel="noopener noreferrer">
                <FaLinkedin />
              </a>
              <a
                href="https://www.facebook.com/share/165jkkeQ9a/?mibextid=wwXIfr"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaFacebook />
              </a>
            </div>
          </div>
          <div className={cx('right-section')}>
            <div className={cx('background-container')}>
              {imgBgrList.map((img, index) => (
                <img 
                  key={index}
                  src={img} 
                  alt={`Background ${index + 1}`} 
                  className={cx('background-image', { 
                    'active': index === currentBgrIndex,
                    'transitioning': isTransitioning && index === currentBgrIndex
                  })} 
                  style={{ zIndex: index === currentBgrIndex ? 10 : 1 }}
                />
              ))}
            </div>
            <div className={cx('info-section')}>
              <div className={cx('name-section')}>
               <div className={cx("name-clip")}>
                  <h1>Ngô Gia Quyến</h1>
                  <span className={cx('role')}>Fullstack Developer</span>
               </div>
              </div>
              <div className={cx('contact-info')} ref={contactRef}>
                <div className={cx('contact-item', 'custom-rectangle')}>
                  <a href={`mailto:${email}`} className={cx('contact-item-link')}>
                    <FaEnvelope />
                    <span>{email}</span>
                  </a>
                </div>
                <div className={cx('contact-item', 'custom-rectangle')}>
                  <a href={`tel:${phone}`} className={cx('contact-item-link')}>
                    <FaPhone />
                    <span>{phone}</span>
                  </a>
                </div>
              </div>
              {/* <button className={cx('cv-button')} onClick={handleDownloadCv}>
                <FaDownload />
                <span>Download CV</span>
              </button> */}
            </div>
          </div>
        </div>
      </div>
      <div className={cx('main-content')} ref={educationRef}>
        <div className={cx('education-content')}>
          <div className={cx('education-main')}>
            <div className={cx('gif-list')}>
              <GifViewer src={images.flyingBirth} />
              <GifViewer src={images.angry} />
            </div>
            <h3>
              Trường Đại Học Công Nghệ Thông Tin Và Truyền Thông <span className={cx('province')}>Thái Nguyên</span>
            </h3>
            <div className={cx('education-info')}>
              <span>2022 - 2026</span>
              <span>Chuyên ngành: Kỹ thuật phần mềm</span>
              <span>GPA: 3.85/4.0</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SocialProfile;